import { render, staticRenderFns } from "./createOrUpdate.vue?vue&type=template&id=4313ea00&scoped=true"
import script from "./createOrUpdate.vue?vue&type=script&lang=js"
export * from "./createOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./createOrUpdate.vue?vue&type=style&index=0&id=4313ea00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4313ea00",
  null
  
)

export default component.exports